// extracted by mini-css-extract-plugin
export default {"pl1":"Spinner_pl1__RG+TP","pl1g":"Spinner_pl1g__WXPDy","pl1rect":"Spinner_pl1rect__cIGWU","pl1a":"Spinner_pl1a__Jyv+t","pl1b":"Spinner_pl1b__CTBAU","pl1c":"Spinner_pl1c__AZro+"};